import { KoobInputSelect } from '@koob/ui';
import { useField } from 'formik';
import { isObject } from 'lodash';
import { FormField, FormLabel, ErrorMessageWrapper } from 'ui/forms';

const SelectField = ({
  label,
  renderOption,
  onAfterSelect,
  withModal,
  touchRequired = true,
  required,
  ...props
}) => {
  const [field, meta, { setValue, setTouched }] = useField(props);

  const hasError =
    (!touchRequired || Boolean(meta.touched)) && Boolean(meta.error);

  return (
    <FormField>
      {label && (
        <FormLabel>
          {label}
          {required && <span className="ml-1 text-red-500">*</span>}
        </FormLabel>
      )}

      <KoobInputSelect
        {...props}
        value={field.value?.value ?? field.value}
        error={hasError}
        onValueChange={(newValue) => {
          const option = (props.options ?? []).find(
            (option) => option.value === newValue,
          );
          // valueField: store the raw scalar (option[valueField]) instead of
          // the whole option object, same as the pre-KD-3348 Select.
          const value = props.valueField
            ? (option?.[props.valueField] ?? newValue)
            : (option ?? newValue);
          setValue(value);
          setTimeout(() => setTouched(true, true));
          if (Boolean(onAfterSelect)) {
            onAfterSelect(value?.value);
          }
        }}
      />
      {hasError && (
        <ErrorMessageWrapper>
          {isObject(meta.error) ? meta.error?.value : meta.error}
        </ErrorMessageWrapper>
      )}
    </FormField>
  );
};

export default SelectField;
